import { AxiosInstance } from 'axios';
import { IEncryptionKey } from '../models';

export class ElectionEncryptionClient {

    constructor(private axiosClient: AxiosInstance) {

    }

    public get apiUrl() {
        return `/election`;
    }

    public async storeKey(id: string, encryptionKey: IEncryptionKey): Promise<void> {
        await this.axiosClient.post(`${this.apiUrl}/${id}/encryption/storeKey`, encryptionKey);
    }

}
